import React from "react"
import PropTypes from "prop-types"
import Prismic from "prismic-javascript"
import { RichText } from "prismic-reactjs"
import { Link } from "react-router-dom"

import Loading from "../Loading"
import { PRISMIC_URL } from "../../../config"

const client = Prismic.client(PRISMIC_URL)

const renderCategory = (category) => (
  <Link to={`/articles/${category.slug}`}>{category.data.category}</Link>
)

const renderArticlePreviews = (articles, exclude) =>
  articles.map((article, i) => {
    if (!exclude || article.id !== exclude) {
      return (
        <div key={i} className="article-preview">
          <h3>
            <Link to={`/article/${article.uid}`}>
              {RichText.asText(article.data.title)}
            </Link>
          </h3>
          <div className="preview-meta">
            Published in{" "}
            {article.data.category.data
              ? renderCategory(article.data.category)
              : "Unclassified"}
          </div>
        </div>
      )
    }
    return null
  })

const Articles = ({ category, exclude, titlePrefix, limit, tag }) => {
  const [articles, setArticles] = React.useState(null)
  const [categoryObj, setCategory] = React.useState(null)

  React.useEffect(() => {
    const fetchPrismicData = async () => {
      const predicates = [Prismic.Predicates.at("document.type", "article")]

      if (tag) {
        predicates.push(Prismic.Predicates.at("document.tags", [tag]))
      } else if (category) {
        const categoryDoc = await client.getByUID("article_category", category)
        setCategory(categoryDoc)
        predicates.push(
          Prismic.Predicates.at("my.article.category", categoryDoc.id),
        )
      }

      const doc = await client.query(predicates, {
        orderings: "[my.article.date desc]",
        fetchLinks: "article_category.category",
        pageSize: limit,
      })

      if (doc) {
        setArticles(doc.results)
      }
    }
    fetchPrismicData()
  }, [category, limit, tag])

  if (!articles) return <Loading />

  const hasCategory = category && categoryObj

  return (
    <div className="article-list">
      {hasCategory ? (
        <Link to="/articles" style={{ fontSize: 12 }}>
          &#xab; All Articles
        </Link>
      ) : null}
      <h2 style={{ marginTop: hasCategory ? 0 : "auto" }}>
        {hasCategory
          ? `${titlePrefix} ${categoryObj.data.category} Articles`
          : "All Articles"}
      </h2>
      {renderArticlePreviews(articles, exclude)}
    </div>
  )
}

Articles.propTypes = {
  category: PropTypes.string,
  tag: PropTypes.string,
  exclude: PropTypes.string,
  titlePrefix: PropTypes.string,
  limit: PropTypes.number,
}

Articles.defaultProps = {
  category: null,
  tag: null,
  exclude: null,
  titlePrefix: "All",
  limit: 50,
}

export default Articles
